import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {removeTokenFromStorage} from './core/AuthHelpers'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    logout()
    removeTokenFromStorage() // Limpiar también el token X-TOKEN
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
